import { messages as portugueseMessages } from "./pt";
import { messages as englishMessages } from "./en";
import { messages as spanishMessages } from "./es";
import { messages as frenchMessages } from "./fr";
import { messages as italianMessages } from "./it";
import { dashboardTranslations } from "../dashboardTranslations";
import { customTranslations } from "../customTranslations";

const baseMessages = {
  ...portugueseMessages,
  ...englishMessages,
  ...spanishMessages,
  ...frenchMessages,
  ...italianMessages,
};

const isPlainObject = (value) =>
  value !== null && typeof value === "object" && !Array.isArray(value);

const deepMerge = (target, source) => {
  if (!isPlainObject(target) || !isPlainObject(source)) return target;

  const out = { ...target };
  for (const [key, value] of Object.entries(source)) {
    if (isPlainObject(value) && isPlainObject(out[key])) {
      out[key] = deepMerge(out[key], value);
      continue;
    }
    out[key] = value;
  }
  return out;
};

// Clone to avoid mutating imported language objects.
const messages = Object.fromEntries(
  Object.entries(baseMessages).map(([lng, resource]) => [
    lng,
    {
      ...resource,
      translations: { ...(resource?.translations || {}) },
    },
  ])
);

const applyExtraTranslations = (extra) => {
  if (!isPlainObject(extra)) return;

  for (const [lng, additions] of Object.entries(extra)) {
    const resource = messages[lng];
    if (!resource || !isPlainObject(resource.translations) || !isPlainObject(additions)) continue;
    resource.translations = deepMerge(resource.translations, additions);
  }
};

applyExtraTranslations(dashboardTranslations);
applyExtraTranslations(customTranslations);

const LANGUAGE_ALIASES = {
  "pt-BR": "pt",
  "pt-br": "pt",
  "pt-PT": "pt",
  "pt-pt": "pt",
  "es-ES": "es",
  "es-es": "es",
  "en-US": "en",
  "en-us": "en",
  "fr-FR": "fr",
  "fr-fr": "fr",
  "it-IT": "it",
  "it-it": "it",
};

Object.entries(LANGUAGE_ALIASES).forEach(([alias, base]) => {
  if (messages[alias] || !messages[base]) return;
  messages[alias] = {
    ...messages[base],
    translations: { ...(messages[base].translations || {}) },
  };
});

export { messages };
